import angular from 'angular';

angular.module('cloudX').directive('formKeyCommands', [
  '$parse',
  function($parse) {
    return {
      restrict: 'A',
      require: 'form',
      link: function($scope, $element, $attr, $form) {
        if (!$form) return;
        //Parse ng-cancel attribute
        var fn = $parse($attr.ngCancel);
        //Add cancel function to form controller
        $form.cancel = function() {
          fn($scope, {});
        };

        $element.on('keyup', function(event) {
          if (event.keyCode === 27) {
            //escape
            $scope.$apply($form.cancel);
          } else if (event.keyCode === 13) {
            if ($form.$valid) $element.triggerHandler('submit'); //Trigger ng-submit
          }
        });
      },
    };
  },
]);
